module.exports = __webpack_public_path__ + "assets/fa-brands-400.13685372945d816a2b474fc082fd9aaa.ttf";